import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import React from "react";
import Pagination from "rc-pagination";
import "assets/index.less";
import sendRequest from "hooks/useAxios";

import ArticleCaption from "components/article/ArticleCaption";
import { useParams } from "react-router-dom";
import { articleDataToQuery } from "utils/helperFunctions";
import "components/article/article.css";
import GroupView from "common/Group-View/GroupViewItem";
import Blog from "common/blog/Blog";
import { unixToPersianDate } from "utils/helperFunctions";
export default function SpecificArticles() {
  const [blognews, setBlognews] = useState({
    captionName: "",
    item: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const params = useParams();

  let queryObj = {};
  if (params.query) {
    queryObj = articleDataToQuery(params.query, true);
  } else {
    queryObj.title = "تمامی مطالب";
  }

  useEffect(() => {
    sendRequest("postfilter", {
      hashtags: queryObj.tags.toString(),
      date: queryObj.dateRange[0],
      toTime: queryObj.dateRange[1],
    }).then(({ data }) => {
      setBlognews((prev) => {
        return {
          ...prev,
          item: data.items.reverse().map((value) => {
            return {
              title: value.title,
              description: value.description,
              date: unixToPersianDate(value.mtm),
              image: value.url,
              id: value.id,
            };
          }),
        };
      });
    });

    const sendRequestBasedParams = () => {
      if (params.query) {
        return sendRequest("postfilter", {
          hashtags: queryObj.tags.toString(),
          date: queryObj.dateRange[0],
          toTime: queryObj.dateRange[1],
        });
      } else {
        return sendRequest("postfilter", {});
      }
    };

    sendRequestBasedParams().then(({ data }) => {
      setBlognews((prev) => {
        return {
          ...prev,
          item: data.items.reverse().map((value) => {
            return {
              title: value.title,
              description: value.description,
              date: unixToPersianDate(value.mtm),
              image: value.url,
              id: value.id,
            };
          }),
        };
      });
    });
  }, []);

  const sliceArray = (array) => {
    return array.slice((currentPage - 1) * 12, (currentPage - 1) * 12 + 12);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{queryObj.title}</title>
        {/* <link rel="canonical" href="http://mysite.com/example" /> */}
      </Helmet>
      <ArticleCaption
        captionName={queryObj.title}
        captionColor={"#1c2140"}
      ></ArticleCaption>

      {blognews.item.length !== 0 ? (
        <GroupView
          Component={Blog}
          numberOf={blognews.item.length}
          specificItems={sliceArray(blognews.item)}
          isFilteredPage={true}
          title=""
          type={1}
          isNotEditable={true}
        ></GroupView>
      ) : (
        <span className="m-4 pt-4 fw-bold">آیتمی موجود نیست.</span>
      )}

      <Pagination
        className="text-center my-2"
        total={blognews.item.length}
        pageSize={12}
        current={currentPage}
        hideOnSinglePage={true}
        onChange={(page) => {
          setCurrentPage(page);
        }}
      />
    </>
  );
}
